import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'

export function loyaltyContext(account: App.LoyaltyAccount | undefined) {
  return comluxgroup.createLoyalty_1_0_1({
    isMember: !!account,
    /** @TODO add 'infinite' tier to contract-data-event-schemas */
    tier: account?.tier === 'infinite' ? undefined : account?.tier,
    membershipNumber: account?.accountNumber,
    points: account?.points,
    statusCredits: account?.statusCredits,
  })
}
